import React from 'react';
import { Checkbox } from '@material-ui/core';
import UserRow from './UserRow'

function Progress() {
    return (
        <div>
            <UserRow />
            <UserRow />
            <UserRow />
            <UserRow />
        </div>
    )
}

export default Progress